import React from 'react';
import { Star } from 'lucide-react';
import { formatSyncDate } from '../utils/dateFormat';

// Render n filled stars + (5 - n) empty stars. Used by both the landing page
// strip and the full /reviews page so the visual is consistent.
export const Stars = ({ value, size = 'h-4 w-4' }) => (
    <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => (
            <Star
                key={n}
                className={`${size} ${n <= value ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`}
            />
        ))}
    </div>
);

const formatAuthor = (r) => r.displayName?.trim() || 'Anonymous';

export const ReviewCard = ({ review }) => (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 flex flex-col gap-2">
        <Stars value={review.rating} />
        {review.text && (
            <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
                {review.text}
            </p>
        )}
        <div className="text-xs text-gray-500 mt-auto pt-2 border-t border-gray-100 flex justify-between">
            <span className="font-medium">{formatAuthor(review)}</span>
            {review.createdAt && <span>{formatSyncDate(review.createdAt)}</span>}
        </div>
    </div>
);

const ReviewsList = ({ reviews, emptyMessage = 'No reviews yet.', columns = 'sm:grid-cols-2 lg:grid-cols-3' }) => {
    if (!reviews || reviews.length === 0) {
        return <p className="text-sm text-gray-500 text-center py-8">{emptyMessage}</p>;
    }
    return (
        <div className={`grid grid-cols-1 ${columns} gap-4`}>
            {reviews.map((r) => <ReviewCard key={r.id} review={r} />)}
        </div>
    );
};

export default ReviewsList;
